$(function() {
	$(el("mainContainer")).on('click', '#btnSendPassword', function() {
		$(el('btnSendPassword')).prop("disabled",true);

		var frmPassword = $('#frmForgotPassword');
		validateEmailForPassword(frmPassword);
		return false;
	});

	$(el("frmForgotPassword")).on('keyup','#inputEmail',function(){
		if($('#frmForgotPassword #inputEmail').closest('.control-group').hasClass('error')){
			$('#frmForgotPassword #inputEmail').closest('.control-group').removeClass('error');
			var frmForgotPassword = $('#frmForgotPassword');
			validateEmail(frmForgotPassword);
		}
	});
});

function validateEmailForPassword(frmPassword) {
	uAjax = "/index.cfm/customer/ajax/sendpassword";
	clearErrors();
	var bValid = validateForm(frmPassword);
	if (bValid) {
		var sParams = '&email=' + encodeURIComponent(frmPassword.find('#inputEmail').val());
		var oCall = callAjax("sendpassword", sParams, "post");
		oCall.success(function(oData) {
			if (oData.errorType == '') {
				showAlert('warning', tPasswordSent, false);
				setTimeout(function() {
					window.location = '/' + sCurrentLanguageCode + '/customer/login'
				}, 2000);
			} else {
				inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el('btnSendPassword')));
				$(el('btnSendPassword')).prop("disabled",false);
			}
		});
	} else {
		$(el('btnSendPassword')).prop("disabled",false);
	}
}